const getIsNaturalPerson = (value: string): boolean => {
  const normalizedValue = value?.toUpperCase()?.normalize('NFD');
  const isLegalPerson =
    normalizedValue.replace(/[\u0300-\u036f]/g, '') === 'SI';

  return !isLegalPerson;
};

export default getIsNaturalPerson;
